module.exports = __webpack_public_path__ + "static/media/21.3178fb8e.mp3";